import gql from 'graphql-tag'

export const GET_LABOUR_2_SERVICE_ORDERS = gql`
  query Labour2ServiceOrders($filter: GetLabour2ServiceOrdersFilter) {
    labour2ServiceOrders(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      labour2ServiceOrders {
        data {
          labourId
          serviceOrderId
          qty
          fee
          labour {
            labourId
            companyId
            code
            name
            description
            fee
          }
        }
        pagination {
          total
          page
          show
          startCursor
          endCursor
        }
      }
    }
  }
`

export const GET_LABOUR_2_SERVICE_ORDER = gql`
  query Labour2ServiceOrder($filter: GetLabour2ServiceOrderFilter!) {
    labour2ServiceOrder(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      labour2ServiceOrder {
        labourId
        serviceOrderId
        qty
        fee
        labour {
          labourId
          companyId
          code
          name
          description
          fee
        }
      }
    }
  }
`

export const CREATE_LABOUR_2_SERVICE_ORDER = gql`
  mutation CreateLabour2ServiceOrder($input: CreateLabour2ServiceOrderInput!) {
    createLabour2ServiceOrder(input: $input) {
      errorCode
      errorName
      isSuccessful
      message
      status
      createLabour2ServiceOrder {
        labourId
        serviceOrderId
        qty
        fee
        labour {
          labourId
          companyId
          code
          name
          description
          fee
        }
      }
    }
  }
`

export const DELETE_LABOUR_2_SERVICE_ORDER = gql`
  mutation DeleteLabour2ServiceOrder($input: DeleteLabour2ServiceOrderInput!) {
    deleteLabour2ServiceOrder(input: $input) {
      deleteLabour2ServiceOrder {
        fee
        labour {
          code
          companyId
          labourId
          name
          description
          fee
        }
        labourId
        serviceOrderId
        qty
      }
      message
      isSuccessful
      status
      errorName
      errorCode
    }
  }
`

export const UPDATE_LABOUR_2_SERVICE_ORDER = gql`
  mutation UpdateLabour2ServiceOrder($input: UpdateLabour2ServiceOrderInput!) {
    updateLabour2ServiceOrder(input: $input) {
      updateLabour2ServiceOrder {
        labourId
        serviceOrderId
        qty
        fee
        labour {
          labourId
          companyId
          code
          name
          description
          fee
        }
      }
      isSuccessful
      errorCode
      errorName
      message
      status
    }
  }
`
